<template>
    <div class="payDataSource">
        <!--顶部按钮部分-->
        <div class="btns">
            <el-button type="primary" @click="deleteData">删除</el-button>
            <el-button type="primary" @click="exportExcele">导出</el-button>
            <el-button title="导入" type="primary" @click="importSubEngineer()">导入</el-button>
            <el-button type="primary" @click="exportPlatform">下载模板</el-button>
            <!--            <el-button type="primary" @click="downLoadExcel">下载模板</el-button>-->
        </div>
        <!--日期切换部分-->
        <el-form :inline="true" :model="searchForm" ref="payDataSourceForm">
            <el-form-item label="日期切换">
                <el-date-picker
                        v-model="searchForm.enterDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :picker-options="pickerOptions"
                        placeholder="请切换日期"
                        :clearable="false"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="项目部" prop="deptName">
                <el-select v-model="searchForm.deptName" placeholder="请选择" clearable>
                    <el-option v-for="item in deptNameList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="primary" @click="resetData">重置</el-button>
        </el-form>

        <!--        表格数据部分-->
        <div class="mainContentWrap">
            <div class="mainContent">
                <div class="cardBox" v-if="!tableDatas||tableDatas.length<1">
                    <div class="deptName">暂无数据</div>
                    <div class="payContent" >
                        <div class="projectName">暂无数据</div>
                        <div class="payContenTitle">费用类别</div>
                        <div class="amount">
                            项目所属年度
                            <span></span>
                            项目合同金额
                            <span></span>
                            已完成工程量
                            <span></span>
                            已上报计量金额
                            <span></span>
                            已收计量金额
                            <span></span>
                            收集团拨款金额
                            <span></span>
                        </div>
                        <div class="tableWrap" >
                            <div class="tableTitle">暂无数据</div>
                            <el-table
                                    :data="emptyData"
                                    show-summary
                                    :summary-method="getSummaries"
                                    sum-text="小计"
                                    border
                                    style="width: 100%"
                            >
                                <el-table-column label="序号" align="right" header-align="center" width="50">
                                    <template slot-scope="scope">{{scope.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column
                                        prop="partyB"
                                        label="合作单位"
                                        align="center"
                                        header-align="center"
                                        width="150"
                                ></el-table-column>
                                <el-table-column
                                        prop="content"
                                        label="合同内容"
                                        align="center"
                                        header-align="center"
                                        width="150"
                                ></el-table-column>
                                <el-table-column
                                        prop="amount"
                                        label="合同金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="cost"
                                        label="工程施工成本"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="alreadyPay"
                                        label="已付款金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="debtAmount"
                                        label="欠款金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="alreadyPayPct"
                                        label="已付款比例"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ></el-table-column>
                                <el-table-column
                                        prop="thisPay"
                                        label="本次拟付款"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="thisPayPct"
                                        label="再付款比例"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ></el-table-column>
                                <el-table-column prop="remark" label="备注"></el-table-column>
                                <el-table-column
                                        prop="checkInfo"
                                        label="导入标识"
                                        align="center"
                                        header-align="center"
                                        width="80"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="cardBox" v-for="item in tableDatas" :key="item.key">
                    <div class="deptName">{{item.key}}</div>
                    <div class="payContent" v-for="(subIem,index) in item.data" :key="index">
                        <div class="projectName">{{subIem.projectName}}</div>
                        <div class="payContenTitle">费用类别</div>
                        <div class="amount">
                            项目所属年度
                            <span>{{subIem['payMapList'][0]['data'][0]['year']}}年</span>
                            项目合同金额
                            <span>{{formatCurrency(subIem.projectAmount)}}</span>
                            已完成工程量
                            <span>{{formatCurrency(subIem.finishAmount)}}</span>
                            已上报计量金额
                            <span>{{formatCurrency(subIem.reportAmount)}}</span>
                            已收计量金额
                            <span>{{formatCurrency(subIem.receiveAmount)}}</span>
                            收集团拨款金额
                            <span>{{formatCurrency(subIem.groupAmount)}}</span>
                        </div>
                        <div class="tableWrap" v-for="tableItem in subIem.payMapList" :key="tableItem.key">
                            <div class="tableTitle">{{tableItem.key}}</div>
                            <el-table
                                    :data="tableItem.data"
                                    show-summary
                                    :summary-method="getSummaries"
                                    sum-text="小计"
                                    border
                                    style="width: 100%"
                            >
                                <el-table-column label="序号" align="right" header-align="center" width="50">
                                    <template slot-scope="scope">{{scope.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column
                                        prop="partyB"
                                        label="合作单位"
                                        align="center"
                                        header-align="center"
                                        width="150"
                                ></el-table-column>
                                <el-table-column
                                        prop="content"
                                        label="合同内容"
                                        align="center"
                                        header-align="center"
                                        width="150"
                                ></el-table-column>
                                <el-table-column
                                        prop="amount"
                                        label="合同金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="cost"
                                        label="工程施工成本"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="alreadyPay"
                                        label="已付款金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="debtAmount"
                                        label="欠款金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="alreadyPayPct"
                                        label="已付款比例"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ></el-table-column>
                                <el-table-column
                                        prop="thisPay"
                                        label="本次拟付款"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="thisPayPct"
                                        label="再付款比例"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ></el-table-column>
                                <el-table-column prop="remark" label="备注"></el-table-column>
                                <el-table-column
                                        prop="checkInfo"
                                        label="导入标识"
                                        align="center"
                                        header-align="center"
                                        width="80"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 导入成功之后的弹窗-->
        <div class="dialogWrap">
            <el-dialog title="提示" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
                <div class="cardBox">
                    <div class="payContent">
                        <div class="tableWrap">
                            <el-table :data="dialogData" border style="width: 100%">
                                <el-table-column label="序号" align="right" header-align="center" width="50">
                                    <template slot-scope="scope">{{scope.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column
                                        prop="partyB"
                                        label="合作单位"
                                        align="center"
                                        header-align="center"
                                        width="150"
                                ></el-table-column>
                                <el-table-column
                                        prop="content"
                                        label="合同内容"
                                        align="center"
                                        header-align="center"
                                        width="150"
                                ></el-table-column>
                                <el-table-column
                                        prop="amount"
                                        label="合同金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="cost"
                                        label="工程施工成本"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="alreadyPay"
                                        label="已付款金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="debtAmount"
                                        label="欠款金额"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="alreadyPayPct"
                                        label="已付款比例"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ></el-table-column>
                                <el-table-column
                                        prop="thisPay"
                                        label="本次拟付款"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ><template slot-scope="scope">
                                  {{formatCurrency(scope.row[scope.column.property])}}
                                </template></el-table-column>
                                <el-table-column
                                        prop="thisPayPct"
                                        label="再付款比例"
                                        align="center"
                                        header-align="center"
                                        width="100"
                                ></el-table-column>
                                <el-table-column prop="remark" label="备注"></el-table-column>
                                <el-table-column
                                        prop="checkInfo"
                                        label="导入标识"
                                        align="center"
                                        header-align="center"
                                        width="80"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible=false">取 消</el-button>
          <el-button type="primary" @click="dialogConfirm">确 定</el-button>
        </span>
            </el-dialog>
        </div>
        <!-- 导入数据源 -->
        <upload-dialog
                :isShow="showUploadDialog"
                @close="closeDialogAction"
                :isImportRelorPay="isImportReceiveDialog"
                @saveImportItem="saveImportItem"
        />
    </div>
</template>

<script>
    import {
        deleteAllPay,
        doImportPay,
        exportPay,
        getMaxDatePay,
        importPay,
        getListPay,
        getPayDropDownDept,
        exportExcelService2,
        getPayTemplate
    } from "../../services/dataCenterService";
    import UploadDialog from "./commonCell/UploadDialog"; //导入组件
    export default {
        name: "payDataSource",
        components: {
            UploadDialog
        },
        data() {
            return {
                searchForm: {
                    enterDate: "",
                    deptName: ""
                },
                emptyData:[],
                maxDate: "",
                deptNameList: [],
                tableDatas: [],
                isImportReceiveDialog: false, //标记是否为导入应付账款数据源
                showUploadDialog: false, //对话框可见性
                pickerOptions: {
                    disabledDate: this.disabledDate
                },
                dialogVisible: false,
                dialogData: []
            };
        },
        created() {
            //获取项目部
            getPayDropDownDept().then(res => {
                if (res.code === 10000000) {
                    this.deptNameList = res.data;
                    if (this.$route.params && this.$route.params.deptName) {
                        this.searchForm.deptName = this.$route.params.deptName;
                        this.$route.params.deptName = ''
                    }
                }
            });
            getMaxDatePay().then(res => {
                if (res.code === 10000000) {
                    this.searchForm.enterDate = res.data;
                    this.maxDate = res.data;
                    if (this.$route.params && this.$route.params.enterDate) {
                        this.searchForm.enterDate = this.$route.params.enterDate;
                        this.$route.params.enterDate = ''
                    }
                    setTimeout(() => {
                        this.search();
                    }, 20);
                }
            });
        },
        methods: {
            disabledDate(time) {
                // return time.getTime() > new Date(this.maxDate);
                return false;
            },
            search() {
                getListPay(this.searchForm).then(res => {
                    if (res.code === 10000000) {
                        if (res.data.length == 1 && res.data[0].data[0].payMapList.length < 1) {
                            this.tableDatas = []
                        } else {
                            this.tableDatas = res.data;
                        }
                    }
                });
            },
            resetData() {
                this.$refs["payDataSourceForm"].resetFields();
            },
            //删除
            deleteData() {
                this.$confirm("确定要删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let params = {};
                    if(this.searchForm.enterDate){
                        params.enterDate=this.searchForm.enterDate
                    }else{
                        this.$alert('请选择日期', "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                        return
                    }
                    deleteAllPay(params).then(res => {
                        if (res.code === 10000000) {
                            this.$message.success("删除成功");
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    });
                });
            },
            dialogConfirm() {
                this.$confirm("确定要保存数据吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let params = {};
                    params.enterDate = this.searchForm.enterDate;
                    params.projectPayVOList = this.dialogData;
                    doImportPay(params)
                        .then(res => {
                            if (res.code === 10000000) {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                            } else if (res.code >= 20000000) {
                                this.$alert(res.msg, "提示", {
                                    confirmButtonText: "确定",
                                    type: "warning"
                                });
                            } else {
                                this.$alert("系统异常", "提示", {
                                    confirmButtonText: "确定",
                                    type: "warning"
                                });
                            }
                        })
                        .catch(() => {
                            this.$alert("系统异常", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        });
                });
            },
            //导出
            exportExcele() {
                exportPay(this.searchForm)
                    .then(res => {
                        if (res.code == 10000000) {
                            exportExcelService2(res.data).then(res1 => {
                                this.$alert("导出成功", "提示", {
                                    confirmButtonText: "确定"
                                });
                            });
                        } else if (res.code >= 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$alert("系统异常", "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    })
                    .catch(() => {
                    });
            },
            //导入
            importSubEngineer() {
                if(!this.searchForm.enterDate){
                    this.$alert("请先选择日期，再导入数据。", "提示", {
                        confirmButtonText: "确定"
                    });
                    return
                }
                this.$confirm(
                    "确定要导入 " + this.searchForm.enterDate + " 数据吗",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                ).then(() => {
                    this.isImportReceiveDialog = false; //标记是否为应收账款数据源
                    this.showUploadDialog = true;
                });
            },
            //关闭导入对话框
            closeDialogAction() {
                this.showUploadDialog = false;
            },
            //显示导入数据
            saveImportItem(selectItems) {
                if (selectItems.length > 0) {
                    this.dialogVisible = true;
                    this.dialogData = selectItems;
                }
            },
            //下载模板
            exportPlatform() {
                getPayTemplate().then(
                    res => {
                        console.log(res);
                        if (res.code == 10000000) {
                            exportExcelService2(res.data).then(res1 => {
                                // this.$alert("成功", "提示", {
                                //   confirmButtonText: "确定"
                                // });
                            });
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$message.error("系统异常");
                    }
                );
            },
            //表格部分计算问题
            //设置小计
            getSummaries(param) {
                let _this = this;
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 1) {
                        sums[index] = "小计";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (
                        !values.every(value => isNaN(value)) &&
                        (column.property == "amount" ||
                            column.property == "cost" ||
                            column.property == "alreadyPay" ||
                            column.property == "debtAmount" ||
                            column.property == "thisPay")
                    ) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        // sums[index] += '';
                    } else {
                        sums[index] = "";
                    }
                });

                sums[7] = ((Number(sums[5]) * 100) / Number(sums[4])).toFixed(1) + "%";
                sums[9] =
                    (((Number(sums[5]) + Number(sums[8])) * 100) / Number(sums[4])).toFixed(
                        1
                    ) + "%";
                sums[3]=this.formatCurrency(sums[3])
                sums[4]=this.formatCurrency(sums[4])
                sums[5]=this.formatCurrency(sums[5])
                sums[6]=this.formatCurrency(sums[6])
                sums[8]=this.formatCurrency(sums[8])
                return sums;
            },
            //数字用逗号隔开
            formatCurrency(num) {
                num = Number(num)
                num = num.toFixed(2)
                if (num === 0) {
                    return 0;
                } else if (num) {
                    num = num.toString().replace(/\$|\,/g, "");
                    if (num === "" || isNaN(num)) {
                        return 0;
                    }
                    var sign = "";
                    if (num.indexOf("-") !== -1) {
                        sign = "-";
                        num = num.substr(1);
                    }
                    var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
                    cents = cents.length > 1 ? cents : "";
                    num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
                    if (cents === "") {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    } else {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    }
                    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                        num =
                            num.substring(0, num.length - (4 * i + 3)) +
                            "," +
                            num.substring(num.length - (4 * i + 3));
                    }
                    return sign + num + cents;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .payDataSource {
        height: calc(100% - 60px);
        text-align: left;
        overflow: hidden;
        background: #ffffff;
        padding: 10px;
        /deep/.el-table__empty-block{
            background: #ffffff;
        }
        .dialogWrap {
            height: 100%;

            /deep/ .el-dialog__wrapper {
                height: 90%;
                overflow: hidden;

                .el-dialog {
                    height: 100%;

                    .el-dialog__body {
                        height: 62%;
                        overflow: auto;
                    }
                }
            }


            .cardBox {
                margin-bottom: 20px;
                /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);*/
                border: 1px solid #c8c8c8;
                background-color: #ffffff;
                padding: 10px;
                color: rgba(0, 0, 0, 1);

                .deptName {
                    display: inline-block;
                    background: #5b9bd5;
                    padding: 4px 24px;
                    color: #ffffff;
                    margin-bottom: 10px;
                }

                .payContent {
                    background: #dae2f3;
                    margin-bottom: 10px;
                    border: 1px solid #9cc3e5;

                    .projectName {
                        background: #dae2f3;
                        border-bottom: 2px solid #9cc3e5;
                        line-height: 30px;
                        text-indent: 20px;
                    }

                    .payContenTitle {
                        margin-top: 5px;
                        padding: 0 20px;
                    }

                    .amount {
                        line-height: 40px;
                        padding: 0 20px;

                        span {
                            border: 1px solid #c8c8c8;
                            background: #d8d8d8;
                            padding: 2px 8px;
                            margin: 0 12px 0 3px;
                        }
                    }

                    .tableWrap {
                        margin: 0 20px 10px 20px;
                        padding: 10px;
                        border: 1px solid #c8c8c8;
                        background-color: #f2f2f2;

                        .tableTitle {
                            display: inline-block;
                            background: #5b9bd5;
                            padding: 4px 24px;
                            color: #ffffff;
                            margin-bottom: 10px;
                        }
                    }
                }

                .el-table {
                    background: #f2f2f2;
                    border: 1px solid #c8c8c8;
                    /*表头*/
                    /deep/ .el-table__header-wrapper {
                        .el-table__header thead tr th {
                            background: #ed7d31;
                            padding: 0;
                            border-color: #c8c8c8;

                            .cell {
                                text-align: center;
                                color: #ffffff;
                                line-height: 30px;
                            }
                        }
                    }

                    /*表格*/
                    /deep/ .el-table__body-wrapper .el-table__body tbody tr td {
                        padding: 0;
                        margin-top: 10px;
                        border-bottom: 1px solid #c8c8c8;
                        border-right: 1px solid #c8c8c8;

                        .cell {
                            text-align: center;
                            line-height: 24px;
                            color: #666;
                        }
                    }

                    /*小计部分*/
                    /deep/ .el-table__footer-wrapper {
                        margin-top: 10px;

                        .el-table__footer tbody tr td {
                            padding: 0;
                            background: #ffffff;
                            border-top: 1px solid #c8c8c8;
                            border-right: 1px solid #c8c8c8;

                            .cell {
                                text-align: center;
                            }
                        }
                    }
                }
            }
        }

        .uploadDiv {
            display: inline-block;
            margin: 0 10px;

            /deep/ .el-button span {
                font-size: 14px !important;
            }

            /deep/ .el-upload-list {
                display: none;
            }
        }

        .el-button--primary {
            background: #5b9bd5;
        }

        .btns {
            margin-bottom: 10px;
        }

        .mainContentWrap {
            width: 100%;
            overflow: auto;
            height: calc(100% - 100px);

            .mainContent {
                width: calc(100% - 10px);
                min-width:1600px;

                .cardBox {
                    margin-bottom: 20px;
                    /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);*/
                    border: 1px solid #c8c8c8;
                    background-color: #ffffff;
                    padding: 10px;
                    color: rgba(0, 0, 0, 1);

                    .deptName {
                        display: inline-block;
                        background: #5b9bd5;
                        padding: 4px 24px;
                        color: #ffffff;
                        margin-bottom: 10px;
                    }

                    .payContent {
                        background: #dae2f3;
                        margin-bottom: 10px;
                        border: 1px solid #9cc3e5;

                        .projectName {
                            background: #dae2f3;
                            border-bottom: 2px solid #9cc3e5;
                            line-height: 30px;
                            text-indent: 20px;
                        }

                        .payContenTitle {
                            margin-top: 5px;
                            padding: 0 20px;
                        }

                        .amount {
                            line-height: 40px;
                            padding: 0 20px;

                            span {
                                border: 1px solid #c8c8c8;
                                background: #d8d8d8;
                                padding: 2px 8px;
                                margin: 0 12px 0 3px;
                            }
                        }

                        .tableWrap {
                            margin: 0 20px 10px 20px;
                            padding: 10px;
                            border: 1px solid #c8c8c8;
                            background-color: #f2f2f2;

                            .tableTitle {
                                display: inline-block;
                                background: #5b9bd5;
                                padding: 4px 24px;
                                color: #ffffff;
                                margin-bottom: 10px;
                            }
                        }
                    }

                    .el-table {
                        background: #f2f2f2;
                        border: 1px solid #c8c8c8;
                        /*表头*/
                        /deep/ .el-table__header-wrapper {
                            .el-table__header thead tr th {
                                background: #ed7d31;
                                padding: 0;
                                border-color: #c8c8c8;

                                .cell {
                                    text-align: center;
                                    color: #ffffff;
                                    line-height: 30px;
                                }
                            }
                        }

                        /*表格*/
                        /deep/ .el-table__body-wrapper .el-table__body tbody tr td {
                            padding: 0;
                            margin-top: 10px;
                            border-bottom: 1px solid #c8c8c8;
                            border-right: 1px solid #c8c8c8;

                            .cell {
                                text-align: center;
                                line-height: 24px;
                                color: #666;
                            }
                        }

                        /*小计部分*/
                        /deep/ .el-table__footer-wrapper {
                            margin-top: 10px;

                            .el-table__footer tbody tr td {
                                padding: 0;
                                background: #ffffff;
                                border-top: 1px solid #c8c8c8;
                                border-right: 1px solid #c8c8c8;

                                .cell {
                                    text-align: center;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>

